

var article = `
Para **actualizar el sistema** hay que usar una **lista de repositorios más nuevos**.

Hay **dos** opciones:

1. *Elegir* una de las que tengo preparadas.

2. *Armarlos* manualmente.

## 1. Elegir una lista preparada

* Están en este [enlace de listas de repositorios](/blog/lista-de-repositorios).

* Y después ir directamente a este [enlace para configurar los repositorios](/blog/configuracion-de-repositorios-linux).

## 2. Armarlos manualmente

* Primero ingresar al [sitio de distribuciones de Ubuntu](http://us.archive.ubuntu.com/ubuntu/dists) para ver cuáles opciones hay disponibles.

* Cuando tenemos elegido el **nombre de la distribución** sólo queda armarlos, *explicado abajo*.

### Armar repositorios

Simplemente hay que reemplazar **nombreDistro** por el nombre de la **distribución** que queremos.

Después hay que ir a este [enlace para saber cómo configurar los repositorios](/blog/configuracion-de-repositorios-linux) en Linux.

Parece dificil pero siguen un **patrón simple**.

> deb http://us.archive.ubuntu.com/ubuntu/ **nombreDistro** main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **nombreDistro** main restricted
> deb http://us.archive.ubuntu.com/ubuntu/ **nombreDistro**-updates main restricted
> deb-src http://us.archive.ubuntu.com/ubuntu/ **nombreDistro**-updates main restricted
> 
> deb http://us.archive.ubuntu.com/ubuntu/ **nombreDistro** universe
> deb-src http://us.archive.ubuntu.com/ubuntu/ **nombreDistro** universe
> deb http://us.archive.ubuntu.com/ubuntu/ **nombreDistro**-updates universe
> deb-src http://us.archive.ubuntu.com/ubuntu/ **nombreDistro**-updates universe
> 
> deb http://us.archive.ubuntu.com/ubuntu/ **nombreDistro** multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **nombreDistro** multiverse
> deb http://us.archive.ubuntu.com/ubuntu/ **nombreDistro**-updates multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **nombreDistro**-updates multiverse
> 
> deb http://us.archive.ubuntu.com/ubuntu/ **nombreDistro**-backports main restricted universe multiverse
> deb-src http://us.archive.ubuntu.com/ubuntu/ **nombreDistro**-backports main restricted universe multiverse
> 
> deb http://archive.canonical.com/ubuntu **nombreDistro** partner
> deb-src http://archive.canonical.com/ubuntu **nombreDistro** partner
> 
> deb http://security.ubuntu.com/ubuntu **nombreDistro**-security main restricted
> deb-src http://security.ubuntu.com/ubuntu **nombreDistro**-security main restricted
> deb http://security.ubuntu.com/ubuntu **nombreDistro**-security universe
> deb-src http://security.ubuntu.com/ubuntu **nombreDistro**-security universe
> deb http://security.ubuntu.com/ubuntu **nombreDistro**-security multiverse
> deb-src http://security.ubuntu.com/ubuntu **nombreDistro**-security multiverse
`;

export default article;